module.exports = __webpack_public_path__ + "img/digital-signature.69687967.svg";